// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Journey A · Membership / Trial ─────────────────────────── */

.ms-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 16px;
}

.ms-banner--trial {
  background: rgba(69, 230, 194, 0.08);
  border: 1px solid var(--line);
  color: var(--muted);
}
.ms-banner--trial strong { color: var(--ink); }

.ms-banner--expired {
  background: rgba(239, 68, 68, 0.10);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: var(--ink);
}

.ms-banner__cta {
  flex: 0 0 auto;
  padding: 7px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  border: 1px solid var(--teal);
  color: var(--teal);
  white-space: nowrap;
}
.ms-banner__cta:hover { background: rgba(69, 230, 194, 0.12); }
.ms-banner__cta--solid {
  background: var(--teal);
  color: var(--troly-action-ink);
  border-color: var(--teal);
}
.ms-banner__cta--solid:hover { filter: brightness(1.05); }

/* Chip de número de miembro */
.ms-member-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .04em;
  background: rgba(200, 165, 91, 0.14);
  color: var(--troly-brass);
  border: 1px solid rgba(200, 165, 91, 0.3);
}
/* Variante pública en el perfil (debajo del nombre, antes de stats).
   Centrado vertical entre el elemento previo y los botones: el previo
   (locación/followers/bio, margin-bottom 10px) + 6px = 16px arriba,
   y 16px abajo hasta .profile-actions. */
.ms-member-chip--public { margin: 6px auto 16px; }

/* ── Modal: membresía gratis ─────────────────────────────────── */
.ms-modal { max-width: 460px; }
.ms-modal__intro,
.ms-modal__foot { font-size: 13px; color: var(--muted); line-height: 1.55; }
.ms-modal__foot { margin-top: 16px; }
.ms-modal__unlocked {
  font-size: 14px; line-height: 1.5;
  background: rgba(69, 230, 194, 0.1);
  border: 1px solid rgba(69, 230, 194, 0.3);
  border-radius: 10px; padding: 12px 14px; margin-top: 8px;
}

.ms-steps {
  list-style: none; padding: 0; margin: 16px 0 0;
  display: grid; gap: 10px;
  font-size: 13px; color: var(--ink); line-height: 1.5;
}
.ms-steps strong { color: var(--teal); margin-right: 4px; }

.ms-code-inline {
  font-family: var(--troly-font-mono, monospace);
  font-weight: 700; letter-spacing: .08em;
  color: var(--teal);
  background: rgba(69, 230, 194, 0.1);
  padding: 2px 8px; border-radius: 6px;
}

.ms-progress-block {
  margin-top: 18px;
  display: grid; gap: 12px;
  padding: 14px; border-radius: 10px;
  background: var(--bg); border: 1px solid var(--line);
}
.ms-progress-row { display: grid; gap: 6px; }
.ms-progress-label { font-size: 11px; color: var(--muted); letter-spacing: .04em; }

.ms-prog { display: flex; align-items: center; gap: 10px; }
.ms-prog__track {
  flex: 1 1; height: 8px; border-radius: 999px;
  background: rgba(242, 239, 233, 0.12); overflow: hidden;
}
.ms-prog__fill {
  height: 100%; border-radius: 999px;
  background: var(--teal); transition: width .4s ease;
}
.ms-prog__num {
  font-size: 12px; font-weight: 700; color: var(--ink);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.ms-prog__check { color: var(--teal); }

.ms-modal__actions {
  display: flex; gap: 10px; margin-top: 20px;
}
.ms-modal__actions .btn-teal,
.ms-modal__actions .btn-ghost { flex: 1 1; }

/* Form inline "Compartir por correo" */
.ms-email-form { display: grid; gap: 10px; margin-top: 20px; }
.ms-email-input {
  width: 100%; box-sizing: border-box;
  padding: 11px 14px; border-radius: 8px;
  font-size: 14px; color: var(--ink);
  background: var(--bg); border: 1px solid var(--line);
}
.ms-email-input::placeholder { color: var(--muted); }
.ms-email-input:focus {
  outline: none; border-color: var(--teal);
  box-shadow: 0 0 0 2px rgba(69, 230, 194, 0.18);
}
.ms-email-form__row { display: flex; gap: 10px; }
.ms-email-form__row .btn-teal,
.ms-email-form__row .btn-ghost { flex: 1 1; }

.ms-email-feedback {
  font-size: 13px; line-height: 1.45; margin: 12px 0 0;
}
.ms-email-feedback--ok { color: var(--teal); }
.ms-email-feedback--err { color: rgb(239, 68, 68); }

/* ── Números del sorteo (mecánica de dos niveles) ────────────── */
/* Uno por las piezas + uno por cada bloque de referidos. Mono para los
   dígitos: son dato numérico, no copy (design system §3). */
.ms-numbers {
  margin-top: 12px;
  display: grid;
  gap: 8px;
  padding: 16px;
  border-radius: var(--troly-radius-md);
  background: color-mix(in srgb, var(--troly-action) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--troly-action) 26%, transparent);
}
.ms-numbers__label {
  font-size: 11px;
  color: var(--muted);
  letter-spacing: .04em;
  text-transform: uppercase;
}
.ms-numbers__chips { display: flex; flex-wrap: wrap; gap: 8px; }
.ms-numbers__chip {
  font-family: var(--troly-font-mono, monospace);
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--troly-action-ink);
  background: var(--teal);
  padding: 4px 12px;
  border-radius: var(--troly-radius-pill);
}
.ms-numbers__next { font-size: 12px; color: var(--ink80); line-height: 1.5; }
`, "",{"version":3,"sources":["webpack://./src/components/MembershipStatus.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;AACrB;AACA,2BAA2B,iBAAiB,EAAE;;AAE9C;EACE,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;AACA,wBAAwB,oCAAoC,EAAE;AAC9D;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,+BAA+B,wBAAwB,EAAE;;AAEzD,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;;;yCAGyC;AACzC,0BAA0B,qBAAqB,EAAE;;AAEjD,mEAAmE;AACnE,YAAY,gBAAgB,EAAE;AAC9B;kBACkB,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC3E,kBAAkB,gBAAgB,EAAE;AACpC;EACE,eAAe,EAAE,gBAAgB;EACjC,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB,EAAE,kBAAkB,EAAE,eAAe;AAC1D;;AAEA;EACE,gBAAgB,EAAE,UAAU,EAAE,gBAAgB;EAC9C,aAAa,EAAE,SAAS;EACxB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB;AACtD;AACA,mBAAmB,kBAAkB,EAAE,iBAAiB,EAAE;;AAE1D;EACE,8CAA8C;EAC9C,gBAAgB,EAAE,qBAAqB;EACvC,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAE,SAAS;EACxB,aAAa,EAAE,mBAAmB;EAClC,qBAAqB,EAAE,6BAA6B;AACtD;AACA,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C,qBAAqB,eAAe,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAElF,WAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1D;EACE,SAAO,EAAE,WAAW,EAAE,oBAAoB;EAC1C,qCAAqC,EAAE,gBAAgB;AACzD;AACA;EACE,YAAY,EAAE,oBAAoB;EAClC,uBAAuB,EAAE,0BAA0B;AACrD;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;EACpD,kCAAkC,EAAE,mBAAmB;AACzD;AACA,kBAAkB,kBAAkB,EAAE;;AAEtC;EACE,aAAa,EAAE,SAAS,EAAE,gBAAgB;AAC5C;AACA;gCACgC,SAAO,EAAE;;AAEzC,uCAAuC;AACvC,iBAAiB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC7D;EACE,WAAW,EAAE,sBAAsB;EACnC,kBAAkB,EAAE,kBAAkB;EACtC,eAAe,EAAE,iBAAiB;EAClC,qBAAqB,EAAE,6BAA6B;AACtD;AACA,+BAA+B,mBAAmB,EAAE;AACpD;EACE,aAAa,EAAE,yBAAyB;EACxC,8CAA8C;AAChD;AACA,sBAAsB,aAAa,EAAE,SAAS,EAAE;AAChD;iCACiC,SAAO,EAAE;;AAE1C;EACE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB;AACtD;AACA,yBAAyB,kBAAkB,EAAE;AAC7C,0BAA0B,uBAAuB,EAAE;;AAEnD,mEAAmE;AACnE;4DAC4D;AAC5D;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,mEAAmE;EACnE,0EAA0E;AAC5E;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC/D;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,uCAAuC;AACzC;AACA,oBAAoB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE","sourcesContent":["/* ── Journey A · Membership / Trial ─────────────────────────── */\n\n.ms-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  line-height: 1.4;\n  margin-bottom: 16px;\n}\n\n.ms-banner--trial {\n  background: rgba(69, 230, 194, 0.08);\n  border: 1px solid var(--line);\n  color: var(--muted);\n}\n.ms-banner--trial strong { color: var(--ink); }\n\n.ms-banner--expired {\n  background: rgba(239, 68, 68, 0.10);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: var(--ink);\n}\n\n.ms-banner__cta {\n  flex: 0 0 auto;\n  padding: 7px 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid var(--teal);\n  color: var(--teal);\n  white-space: nowrap;\n}\n.ms-banner__cta:hover { background: rgba(69, 230, 194, 0.12); }\n.ms-banner__cta--solid {\n  background: var(--teal);\n  color: var(--troly-action-ink);\n  border-color: var(--teal);\n}\n.ms-banner__cta--solid:hover { filter: brightness(1.05); }\n\n/* Chip de número de miembro */\n.ms-member-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: .04em;\n  background: rgba(200, 165, 91, 0.14);\n  color: var(--troly-brass);\n  border: 1px solid rgba(200, 165, 91, 0.3);\n}\n/* Variante pública en el perfil (debajo del nombre, antes de stats).\n   Centrado vertical entre el elemento previo y los botones: el previo\n   (locación/followers/bio, margin-bottom 10px) + 6px = 16px arriba,\n   y 16px abajo hasta .profile-actions. */\n.ms-member-chip--public { margin: 6px auto 16px; }\n\n/* ── Modal: membresía gratis ─────────────────────────────────── */\n.ms-modal { max-width: 460px; }\n.ms-modal__intro,\n.ms-modal__foot { font-size: 13px; color: var(--muted); line-height: 1.55; }\n.ms-modal__foot { margin-top: 16px; }\n.ms-modal__unlocked {\n  font-size: 14px; line-height: 1.5;\n  background: rgba(69, 230, 194, 0.1);\n  border: 1px solid rgba(69, 230, 194, 0.3);\n  border-radius: 10px; padding: 12px 14px; margin-top: 8px;\n}\n\n.ms-steps {\n  list-style: none; padding: 0; margin: 16px 0 0;\n  display: grid; gap: 10px;\n  font-size: 13px; color: var(--ink); line-height: 1.5;\n}\n.ms-steps strong { color: var(--teal); margin-right: 4px; }\n\n.ms-code-inline {\n  font-family: var(--troly-font-mono, monospace);\n  font-weight: 700; letter-spacing: .08em;\n  color: var(--teal);\n  background: rgba(69, 230, 194, 0.1);\n  padding: 2px 8px; border-radius: 6px;\n}\n\n.ms-progress-block {\n  margin-top: 18px;\n  display: grid; gap: 12px;\n  padding: 14px; border-radius: 10px;\n  background: var(--bg); border: 1px solid var(--line);\n}\n.ms-progress-row { display: grid; gap: 6px; }\n.ms-progress-label { font-size: 11px; color: var(--muted); letter-spacing: .04em; }\n\n.ms-prog { display: flex; align-items: center; gap: 10px; }\n.ms-prog__track {\n  flex: 1; height: 8px; border-radius: 999px;\n  background: rgba(242, 239, 233, 0.12); overflow: hidden;\n}\n.ms-prog__fill {\n  height: 100%; border-radius: 999px;\n  background: var(--teal); transition: width .4s ease;\n}\n.ms-prog__num {\n  font-size: 12px; font-weight: 700; color: var(--ink);\n  font-variant-numeric: tabular-nums; white-space: nowrap;\n}\n.ms-prog__check { color: var(--teal); }\n\n.ms-modal__actions {\n  display: flex; gap: 10px; margin-top: 20px;\n}\n.ms-modal__actions .btn-teal,\n.ms-modal__actions .btn-ghost { flex: 1; }\n\n/* Form inline \"Compartir por correo\" */\n.ms-email-form { display: grid; gap: 10px; margin-top: 20px; }\n.ms-email-input {\n  width: 100%; box-sizing: border-box;\n  padding: 11px 14px; border-radius: 8px;\n  font-size: 14px; color: var(--ink);\n  background: var(--bg); border: 1px solid var(--line);\n}\n.ms-email-input::placeholder { color: var(--muted); }\n.ms-email-input:focus {\n  outline: none; border-color: var(--teal);\n  box-shadow: 0 0 0 2px rgba(69, 230, 194, 0.18);\n}\n.ms-email-form__row { display: flex; gap: 10px; }\n.ms-email-form__row .btn-teal,\n.ms-email-form__row .btn-ghost { flex: 1; }\n\n.ms-email-feedback {\n  font-size: 13px; line-height: 1.45; margin: 12px 0 0;\n}\n.ms-email-feedback--ok { color: var(--teal); }\n.ms-email-feedback--err { color: rgb(239, 68, 68); }\n\n/* ── Números del sorteo (mecánica de dos niveles) ────────────── */\n/* Uno por las piezas + uno por cada bloque de referidos. Mono para los\n   dígitos: son dato numérico, no copy (design system §3). */\n.ms-numbers {\n  margin-top: 12px;\n  display: grid;\n  gap: 8px;\n  padding: 16px;\n  border-radius: var(--troly-radius-md);\n  background: color-mix(in srgb, var(--troly-action) 8%, transparent);\n  border: 1px solid color-mix(in srgb, var(--troly-action) 26%, transparent);\n}\n.ms-numbers__label {\n  font-size: 11px;\n  color: var(--muted);\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n.ms-numbers__chips { display: flex; flex-wrap: wrap; gap: 8px; }\n.ms-numbers__chip {\n  font-family: var(--troly-font-mono, monospace);\n  font-size: 14px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--troly-action-ink);\n  background: var(--teal);\n  padding: 4px 12px;\n  border-radius: var(--troly-radius-pill);\n}\n.ms-numbers__next { font-size: 12px; color: var(--ink80); line-height: 1.5; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
